<template>
  <div class="rentalFiles">
    <h4>Mes avis d'échéances</h4>

    <div class="rentalFiles__table">
      <div class="rentalFiles__table-heading">
        <div class="rentalFiles__table-heading-date">
          Date
        </div>
        <div class="rentalFiles__table-heading-denominated">
          Libellés
        </div>
        <div class="rentalFiles__table-heading-status">
          &nbsp;
        </div>
      </div>

      <div class="rentalFiles__table-item">
        <div class="rentalFiles__table-item-date">
          30/11/2019
        </div>
        <div class="rentalFiles__table-item-denominated">
          Loyer + charge + divers
        </div>
        <div class="rentalFiles__table-item-status">
          <md-icon name="publish" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RentalFiles'
}
</script>

<style lang="scss" scoped>
$c: '.rentalFiles';

#{$c} {
  border-top: solid 1px #e4e7ed;
  padding-top: 32px;
  padding-bottom: 32px;

  &__table {
    margin-top: 24px;
    display: flex;
    flex-direction: column;
    width: 100%;
    min-width: 360px;
    overflow-x: auto;

    &-item {
      &-denominated,
      &-status {
        color: $--color-primary !important;
        i {
          color: $--color-primary !important;
        }
      }
    }

    & > div {
      display: flex;
      width: 100%;
      justify-content: space-between;
      border-bottom: solid 1px #e4e7ed;
      font-size: 14px;

      & > div {
        &:first-child {
          flex: 15% 0;
        }

        &:nth-child(2) {
          flex: 60% 0;
        }

        &:nth-child(3) {
          flex: 25% 0;
          display: flex;
          justify-content: flex-end;
          i {
            position: relative;
            left: -32px;
            transform: rotate(180deg);
          }
        }
      }
    }

    &-heading {
      padding-top: 24px;
      padding-bottom: 24px;
      color: #909399 !important;
    }

    &-item {
      padding-top: 15px;
      padding-bottom: 15px;
      align-items: center;
      color: #606266;

      &-amount,
      &-status {
        color: $--color-primary;
      }
    }
  }
}
</style>